import { motion } from "framer-motion";

const STEPS = [
    {
        num: "1",
        title: "Understand the learner",
        text: "Begin by discussing strengths, goals and areas where support is needed.",
    },
    {
        num: "2",
        title: "Practise with purpose",
        text: "Use guided examples, targeted activities and regular opportunities to apply new skills.",
    },
    {
        num: "3",
        title: "Review progress",
        text: "Share helpful feedback with parents or caregivers and identify next learning steps.",
    },
];

export const Approach = () => (
    <section id="approach" className="scroll-mt-24 border-y border-ground-line/60 bg-ground" data-testid="approach-section">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
            <motion.div
                className="max-w-2xl"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                <p className="text-xs font-bold tracking-widest text-sun uppercase">The YNova approach</p>
                <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                    Encouragement, structure and steady progress.
                </h2>
                <p className="mt-4 text-base text-mist sm:text-lg">
                    Every learner develops at a different pace. YNova Education aims to make English practice
                    supportive, clear and purposeful, helping children grow their skills and confidence over time.
                </p>
            </motion.div>
            <div className="mt-12 grid gap-6 md:grid-cols-3">
                {STEPS.map((step, i) => (
                    <motion.div
                        key={step.num}
                        data-testid={`approach-step-${step.num}`}
                        className="rounded-3xl border border-ground-line/70 bg-ground-deep/60 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-sun/50"
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.55, delay: i * 0.12 }}
                    >
                        <span className="font-heading text-5xl font-black text-sun">{step.num}</span>
                        <h3 className="font-heading mt-4 text-lg font-bold text-ink">{step.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-mist">{step.text}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
